module.exports = __webpack_public_path__ + "assets/img/num1.0b86b53d.png";